<template>
<div class="left-nav" :class="{ 'show-spot': showSpot }">
    <!-- 实景/概况/定位/轨迹的大盒子 -->
    <div class="left-btn-box">
        <div class="item detail" v-if="!isHarmonyosIdentifying && isWeiXin"><!-- detail.nav == 1 &&  -->
            <div @click="boxshow = !boxshow">{{ $t('main.overview') }}</div>
            <transition name="draw">   
                <div class="lists" v-show="boxshow">
                    <div class="spot" v-for="(item, index) in spots" :key='index' @click="gotoDetail(item)">
                        <img :src="item.icon" alt="icon">
                        <div>{{item.title}}</div>
                    </div>
                </div>
            </transition>
        </div>
        <!-- 2022/3/3 临时方案 屏蔽景区通id为2146的景区(金匮公园)的服务按钮 -->
        <div v-if="detail.nav_service == 1 && (sid != 2146 || scenic != 1) && !isHarmonyosIdentifying && isWeiXin" class="item serve-icon">
            <div @click="showSer = !showSer">{{ $t('main.serve') }}</div>
            <transition name="draw">
                <div class="lists"  v-show="showSer">
                    <div class="spot" v-for="(item, index) in sers" :key='index' @click="gotoDetail(item)">
                        <img :src="item.icon" alt="icon">
                        <div>{{item.title}}</div>
                    </div>
                </div>
            </transition>
        </div>
        <div class="item map" @click="clickNav" v-if="isWeiXin">{{leftMenuStatus==1? $t('main.reality') : $t('main.map') }}</div>
        <!-- <div class="item indoor" @click="clickIndoor" v-if="detail.nav_indoor == 1 && scenic == 1 && isNew">{{ $t('main["室内"]') }}</div> -->
        <div class="item customer-flow" @click="showCustomerFlow = true" v-if="isWeiXin">客流</div>

        <div class="items">
            <!-- 改成使用背景的方法显示图标是因为用图片的话在ios的情况下文字会错位 -->
            <div class="item spot-icon" @click="showSpotFun" :style="{background: `#EBF8FF url(${currentIcon ? currentIcon : './../../assets/new_scenic_icon.png'}) no-repeat center 0.1rem/0.36rem 0.36rem`}">{{currentTitle}}
                <!-- <img v-if="currentIcon" :src="currentIcon" alt=""> -->
                <!-- <img v-else src="../../assets/classify_allactive_scenic.png" alt=""> -->
                <!-- <img v-else src="./../../assets/new_scenic_icon.png" alt=""> -->
                <!-- {{currentTitle}} -->
                <!-- <transition name="draw">    -->
                <div class="spot-box"  v-show="showSpot">
                    <div class="title" v-if="isNew">景点设施</div>
                    <div class="spot" v-for="(item, index) in classiryList" :key="index" @click="clickSpot(index,false,item)">
                        <img :src="item.icon" alt="icon">
                        <div>{{item.title}}</div>
                    </div>
                </div>
                <!-- </transition> -->
            </div>
            <div class="item audio-icon" @click="goAudioList" v-if="isWeiXin">
                {{ $t('main.audio') }}
            </div>
            <!-- 景区通景点查找 -->
            <div class="item check-icon" @click="showSearchBoxFun" v-if="isScenic">
                {{ $t('main.search') }}
            </div>
        </div>
    </div>
    <!-- 图层弹框 -->
    <div class="tc-masker" :class="{show: showTcSelectBox}" @click="closeTcSelectBox"></div>
    <div class="tc-select-box" :class="{show: showTcSelectBox}">
        <div class="tc-item" :class="{on: tcId && tcId == item.id}" v-for="(item, index) in selectList" :key="index" @click.stop="openTcMap(index)">{{item.title}}</div>
    </div>

    <CustomerFlow :showCustomerFlow.sync="showCustomerFlow"/>
</div>
</template>

<script>
import Apis from '../../config/apis.js'
import _ from '../../config/util.js'
import icon1 from '@/assets/icon1.png'
import icon2 from '@/assets/icon2.png'
import icon3 from '@/assets/icon3.png'
import icon4 from '@/assets/icon4.png'
import icon5 from '@/assets/icon5.png'
import icon6 from '@/assets/icon6.png'
import icon7 from '@/assets/icon7.png'
import icon8 from '@/assets/icon8.png'
import icon9 from '@/assets/icon9.png'
import icon10 from '@/assets/icon10.png'
import icon11 from '@/assets/icon11.png'
import icon12 from '@/assets/icon12.png'
import {
    Toast
} from 'mint-ui'
import {
    setInterval,
    clearInterval
} from 'timers'
import CustomerFlow from './customer-flow'
export default {
    name: 'LeftNav',
    components: {
        CustomerFlow
    },
    data() {
        return {
            // isScenic: this.$route.query.scenic, // 判断是否景区通
            isScenic: 1, // 判断是否景区通
            showTcSelectBox: false, // 是否显示选择图层框
            selectList: [], // 地图列表
            tcId: 0, // 图层ID
            longitude: '',
            latitude: '',
            map: {}, //地图对象
            interval: null,
            walkingOpen: false,
            markers:[],
            boxshow: true,
            showSer: false,
            showSpot: false,
            classiryList: [],
            vrUrl:'',
            spots: [
                {
                    // title: '景区介绍',
                    title: '介绍',
                    key: 'intro',
                    path: 'packages/city_service/scenic-spot/detail/index?id=',
                    scenicPath: 'pages/scenic/list/index?title=介绍&id=',
                    icon: icon1,
                    icon: 'https://scenic.img.tuliyou.com/static/images/default_page_images/scenic_common/intro.png'
                },
                {
                    // title: '景区活动',
                    title: '活动日历',
                    key: 'active',
                    path: 'packages/scenic/activity/index?sid=',
                    scenicPath: 'pages/scenic/activity/index?sid=',
                    icon: icon2,
                    icon: 'https://scenic.img.tuliyou.com/static/images/default_page_images/scenic_common/active.png'
                },
                {
                    title: '旅游攻略',
                    key: 'gonglue',
                    path: 'packages/scenic/strategy-list/index?sid=',
                    scenicPath: 'pages/scenic/strategy-list/index?type=3sid=',
                    icon: icon3,
                    icon: 'https://scenic.img.tuliyou.com/static/images/default_page_images/scenic_common/gonglue.png'
                },
                {
                    // title: '景区相册',
                    title: '景观相册',
                    key: 'photo',
                    path: 'packages/scenic/album/index?sid=',
                    scenicPath: 'pages/scenic/album/index?sid=',
                    icon: icon4,
                    icon: 'https://scenic.img.tuliyou.com/static/images/default_page_images/scenic_common/photo.png'
                },
                // {
                //     title: '全景VR',
                //     key: 'vr',
                //     path: 'packages/scenic/vr/index?link=',
                //     scenicPath: 'pages/scenic/vr/index?link=',
                //     scenicPath: 'pages/scenic/vr-list/index?sid=',
                //     icon: icon5,
                //     icon: 'https://scenic.img.tuliyou.com/static/images/default_page_images/scenic_common/vr.png'
                // },
                {
                    title: '视频',
                    key: 'video',
                    path: 'packages/city_service/scenic/video-list/index?type=1&sid=',
                    scenicPath: 'pages/scenic/video-list/index?type=1&sid=',
                    icon: icon6,
                    icon: 'https://scenic.img.tuliyou.com/static/images/default_page_images/scenic_common/video.png'
                }
            ],
            sers: [
                {
                    title: '预约停车',
                    key: 'park',
                    icon: icon7,
                    path: 'pages/defect/index?sid=',
                    scenicPath: 'pages/defect/index?sid='
                },
                {
                    title: '预约排队',
                    key: 'queue',
                    icon: icon8,
                    path: 'pages/defect/index?sid=',
                    scenicPath: 'pages/defect/index?sid='
                },
                {
                    title: '租单车',
                    key: 'hire',
                    icon: icon9,
                    path: 'pages/defect/index?sid=',
                    scenicPath: 'pages/defect/index?sid='
                },
                {
                    title: '导游',
                    key: 'guide',
                    icon: icon10,
                    path: 'pages/defect/index?sid=',
                    scenicPath: 'pages/defect/index?sid='
                },
                {
                    title: '充电宝',
                    key: 'charge',
                    icon: icon11,
                    path: 'pages/defect/index?sid=',
                    scenicPath: 'pages/defect/index?sid='
                },
                {
                    title: 'WIFI',
                    key: 'wifi',
                    icon: icon12,
                    path: 'pages/defect/index?sid=',
                    scenicPath: 'pages/defect/index?sid='
                }
            ],
            type: '',
            scenic: '',
            isIphoneX: false,
            showDir: 1, // 判断是否显示视频分类，1：显示，0：隐藏
            currentTitle: '', // 景点
            currentIcon: '',
            showCustomerFlow: false, // 是否显示客流
        }
    },
    props: {
        sid: String
    },
    computed: {
        // 获取当前显示状态
        leftMenuStatus() {
            return this.$store.state.leftMenuStatus
        },
        userLocation() {
            return this.$store.state.userLocation
        },
        isWeiXin() {
            return this.$store.state.isWeiXin
        },
        curClassify() {
            return this.$store.state.curClassify
        },
        isShowSpot() {
            return this.$store.state.isShowSpot
        },
        detail() {
            return this.$store.state.scenicInfo
        },
        isHarmonyosIdentifying() {
            return this.$store.state.isHarmonyosIdentifying
        },
        isNew() {
        return this.$store.state.isNew
        },
    },
    // eslint-disable-next-line no-dupe-keys
    watch: {
        // 检测地图被初始化完成后在执行下面的数据获取
        '$store.state.mapObj'() {
            // 获取是否有多张手绘图
            this.getMultiMap()
        },
        // curClassify() {
        //     // 如果正在显示轨迹，则关闭轨迹
        //     if(this.walkingOpen){
        //         this.walkingOpen=false;
        //         this.closeWalking();
        //     }
        // },
        // isShowSpot(){
        //     if(this.isShowSpot&&this.walkingOpen){
        //         this.walkingOpen=false;
        //         this.closeWalking();
        //     }
        // }
    },
    mounted() {
        // 获取图层ID
        this.tcId = this.$route.query.tcId ? this.$route.query.tcId : 0
        this.type = this.$route.query.type
        // this.scenic = this.$route.query.scenic
        this.scenic = 1
        this.isIphoneX = !(this.$route.query.isIphoneX == 'false')
        this.showDir = !(this.$route.query.switch - 0) ? this.$route.query.switch - 0 : 1
        this.cacheKey = this.$route.query.cacheKey
        this.isH5 = this.$route.query.isH5
        this.uid = this.$route.query.uid
        this.getClassifys()
        // this.getVr()

        if (!this.scenic && !this.currentTitle && !this.currentIcon) {
            // this.currentTitle = '设施'
            this.currentTitle = this.$t('main.facilities')
            this.currentIcon = require('./../../assets/new_scenic_icon.png')
        }

        // // 景区图概况和服务定制
        // if(this.scenic == 1 && this.sid) this.getCustomize()
        // else this.getClassifys()

        // 隐藏POI
        window.hidePOIBox = () => {
            this.showSpot = false
        }
        window.showSpotFun = this.showSpotFun
    },
    methods: {
        goAudioList(){
            if(this.isWeiXin){
                 // 1：景区通地址
                var url = this.scenic == 1 ? '/pages/scenic/audio-list/index?sid=' : '/packages/scenic/audio-list/index?sid='
                window.uni.miniProgram.navigateTo({
                    url: url + this.sid
                })  
                
            }else{
                var url = this.scenic == 1 ? `${this.$scenicUrl+'pages/scenic/audio-list/index?sid='+this.sid}` : `${this.$baseurl+'packages/scenic/audio-list/index?sid='+this.sid}`
                window.location.href = url
            }
        },
        getVr(){
            this.axios.post(Apis.getVr, {sid: this.sid}).then(res => {
                console.log('*****res-VR*****',res)
                this.vrUrl = res.data.vr_url
            })
        },
        gotoDetail(item){
            console.log(item, this.scenic)
            if(this.isWeiXin){
                // scenic == 1: 跳转景区通，否则跳转一机旅游
                var url = this.scenic == 1 ? item.scenicPath : item.path
                // if(item.title == '全景VR'){
                if(item.key == 'vr') {
                    window.uni.miniProgram.navigateTo({
                        url: '/'+url+this.vrUrl+'&sid='+this.sid+ `&title=${ item.title }`
                    })  
                }else{
                    window.uni.miniProgram.navigateTo({
                        url: '/'+url+this.sid+ `&title=${ item.title }`
                    }) 
                }
                
            }else{
                // if(item.title == '全景VR'){
                if(item.key == 'vr'){
                    let baseUrl = this.scenic == 1 ? this.$scenicUrl + item.scenicPath : this.$baseurl + item.path
                    // window.location.href = `${this.$baseurl+item.path+this.vrUrl+'&sid='+this.sid}`
                    // window.location.href = `${ baseUrl + item.path + this.vrUrl + '&sid=' + this.sid }`
                    window.location.href = `${ baseUrl + this.vrUrl + '&sid=' + this.sid }&title=${ item.title }`
                }else{
                    var url = this.scenic == 1 ? `${this.$scenicUrl+item.scenicPath+this.sid}` : `${this.$baseurl+item.path+this.sid}`
                    window.location.href = url + `&title=${ item.title }`
                }
                // console.log('****url',`${this.$baseurl+item.path+this.sid}`)
            }
        },
        async getClassifys(list){
            let res
            if(!list) {
                let allClassifyUrl = Apis.allClassify
                if(this.sid) allClassifyUrl = Apis.allClassify1
                res = await this.axios.post(allClassifyUrl, {
                    sid: this.sid
                })
                
                // 2022/11/29 默认图标和文字修改
                if(!this.currentTitle && !this.currentIcon) {
                    // this.currentTitle = '设施'
                    this.currentTitle = this.$t('main.facilities')
                    this.currentIcon = require('./../../assets/new_scenic_icon.png')
                }

                // // 获取景点的图标和标题 如果没有指定POI 即默认为景点的时候 获取默认图标和标题
                // let viewpoint = res.data.find(v => v.key == 'viewpoint')
                // let cid = this.$route.query.cid
                // if(viewpoint && (!cid || cid === 'undefined')) {
                //     this.currentTitle = viewpoint.title
                //     this.currentIcon = viewpoint.icon
                // }
            }
            // 兼容定制
            else res = {
                data: list
            }

            // console.log('res****',res)
            // 判断之前是否有选中的分类
            const curClassify = this.$store.state.curClassify
            if (!curClassify || curClassify == 'null') {
                res.data.map((el, ix) => {
                    el['selected'] = ix === 0 ? true : false
                })
                // 设置全局当前选中的分类
                this.$store.commit('setCurClassify', res.data[0])
            } else {
                res.data.map(el => {
                    if (el.id == curClassify.id) {
                        el['selected'] = true
                        // 设置全局当前选中的分类
                        this.$store.commit('setCurClassify', el)
                    } else {
                        el['selected'] = false
                    }
                })
            }
            //2022/3/3 临时方案 当是景区通进入并且sid为2146(金匮公园)时，屏蔽购物、住宿、加油站
            if(this.scenic == 1 && this.sid == 2146) {
                res.data = res.data.filter(v => !['购物','住宿','加油站'].includes(v.title))
            }
            // 里水 娱乐 => 玩乐
            if(this.$route.query.scenicType === 'lishui') {
                let el = res.data.find(v => v.id == 7)
                if(el) el.title = '玩乐'
            }
            this.classiryList = res.data
            this.setClassify()
        },
         setClassify() {
            let cid = this.$route.query.cid,
                idx = 0
            if(cid && cid !== 'undefined') {
                idx = this.classiryList.findIndex(item => item.id == cid)
                this.clickSpot(idx, true, this.classiryList[idx])
            }
        },
        clickSpot(idx, needScroll, item) {
            this.classiryList.map((el, ix) => {
                el.selected = ix === idx ? true : false
            })
            if(item) {
                this.currentTitle = item.title
                this.currentIcon = item.icon
            }
            // 设置全局当前选中的分类
            this.$store.commit('setCurClassify', this.classiryList[idx])
            // 选择分类后关闭全部分类选择框
            this.showAll = false
            // 选择分类后滚动条位置滚动
            if (needScroll) {
                // 下标大于等于5才滚动一定位置，否则滚动条位置为0
                this.$nextTick(() => {
                    let element = document.getElementsByClassName('class-box')
                    if (element[0]) {
                        idx >= 4 ? element[0].scrollLeft = idx * 65 : element[0].scrollLeft = 0
                    }
                })
            }

        },
        clickNav() {
            const userLocationMarker = this.$store.state.userLocationMarker
            const map = this.$store.state.mapObj
            // 如果头定位点清楚掉当前地图的定位点
            if (userLocationMarker != '') {
                map.remove([userLocationMarker])
                this.$store.commit('setUserLocationMarker', '')
            }

            if (this.leftMenuStatus === 1) {
                this.$store.commit('setLeftMenuSts', 2)
                this.$router.replace({
                    path: 'map',
                    query: this.$route.query
                    // {
                    //     id: this.sid,
                    //     uid: this.uid,
                    //     tcId: this.tcId,
                    //     type: this.type,
                    //     scenic: this.scenic,
                    //     isIphoneX: this.isIphoneX,
                    //     cacheKey: this.cacheKey,
                    //     isH5: this.isH5
                    // }
                })
            } else {
                this.$store.commit('setLeftMenuSts', 1)
                this.$router.replace({
                    path: '/',
                    query: this.$route.query
                    // {
                    //     id: this.sid,
                    //     uid: this.uid,
                    //     tcId: this.tcId,
                    //     type: this.type,
                    //     scenic: this.scenic,
                    //     isIphoneX: this.isIphoneX,
                    //     cacheKey: this.cacheKey
                    // }
                })
            }
        },
        /**
         * 跳转到室内地图
         */
        clickIndoor() {
            if(this.detail.nav_indoor != 1 || this.scenic != 1 || !this.isNew) return
            if (this.isWeiXin) {
                window.uni.miniProgram.navigateTo({
                    url: `/pages/scenic/tem12-map/index?sid=${this.sid}&type=indoor`
                })
            } else {
                window.location.href = `${this.$baseurl}pages/scenic/tem12-map/index?sid=${this.sid}&type=indoor`
            }
        },
        /**
         * 显示图层选择框
         */
        openTcSelectBox() {
            // 打开选择图层框
            this.showTcSelectBox = true
        },
        /**
         * 隐藏图层选择框
         */
        closeTcSelectBox() {
            // 打开选择图层框
            this.showTcSelectBox = false
        },
        /**
         * 打开图层地图
         */
        openTcMap(ix) {
            this.$store.commit('setLeftMenuSts', 1)
            this.$router.push({
                    path: '/',
                    query: {
                        id: this.sid,
                        tcId: this.selectList[ix].id
                    }
                },
                () => {
                    location.reload()
                }
            )
        },
        getMultiMap() {
            let getMultiMapUrl = Apis.getMultiMap
            if(this.sid) getMultiMapUrl = Apis.getMultiMap1
            this.axios.post(getMultiMapUrl, {
                sid: this.sid
            }).then(res => {
                this.selectList = res.data != '' ? res.data : []
                // 没有图层ID时
                if (this.tcId == 0 && res.data != '') {
                    // 获取最小距离数据索引
                    const minIx = _.calculatePointDistance(
                        res.data,
                        this.userLocation
                    )
                    this.tcId = res.data[minIx].id
                }
            })
        },
        //把组件my-location-btn.vue的搬过来到这里了
        switchList() {
            // 如果点击定位时轨迹正在显示，则关闭轨迹
            if(this.walkingOpen){
                this.walkingOpen=false
                this.closeWalking()
            }
            
            if (this.isWeiXin) {
                this.map = this.$store.state.mapObj
                const userLocationMarker = this.$store.state.userLocationMarker
                // 获取当前地图的限制区域
                const limtBounds = this.map.getLimitBounds()
                // 获取用户当前位置
                _.geolocation().then(res => {
                    const amapLngLat = new AMap.LngLat(res.longitude, res.latitude)
                    if (limtBounds) {
                        // 判断是否在景区范围内
                        if (limtBounds.contains(amapLngLat)) {
                            console.log('手动定位', userLocationMarker)
                            if (userLocationMarker == '') {
                                // 自定义标记点
                                const content =
                                    '<div class="custor-marker"><div class="user-photo"></div></div>'
                                const marker = new AMap.Marker({
                                    content: content,
                                    position: [res.longitude, res.latitude],
                                    offset: new AMap.Pixel(-40, -80),
                                    map: this.map
                                })
                                this.$store.commit('setUserLocationMarker', marker)
                            } else {
                                userLocationMarker.setPosition(amapLngLat)
                                userLocationMarker.setMap(this.map)
                            }
                            // 将地图移动到用户的位置
                            this.map.panTo(amapLngLat)
                        } else {
                            if(window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger') Toast(this.$t('main["当前不在景区范围内！"]'))
                        }
                    } else {
                        if (userLocationMarker == '') {
                            // 自定义标记点
                            const content =
                                '<div class="custor-marker"><div class="user-photo"></div></div>'
                            const marker = new AMap.Marker({
                                content: content,
                                position: [res.longitude, res.latitude],
                                offset: new AMap.Pixel(-40, -80),
                                map: this.map
                            })
                            this.$store.commit('setUserLocationMarker', marker)
                        } else {
                            userLocationMarker.setPosition(amapLngLat)
                            userLocationMarker.setMap(this.map)
                        }
                        // 将地图移动到用户的位置
                        this.map.panTo(amapLngLat)
                    }
                })
            } else {
                this.map = this.$store.state.mapObj
                const userLocationMarker = this.$store.state.userLocationMarker
                this.getCurrentPosition()
                const amapLngLat = new AMap.LngLat(this.longitude, this.latitude)
                    if (userLocationMarker == '') {
                        // 自定义标记点
                        const content =
                            '<div class="custor-marker"><div class="user-photo"></div></div>'
                        const marker = new AMap.Marker({
                            content: content,
                            position: [this.longitude, this.latitude],
                            offset: new AMap.Pixel(-40, -80),
                            map: this.map
                        })
                        this.$store.commit('setUserLocationMarker', marker)
                    } else {
                        userLocationMarker.setPosition(amapLngLat)
                        userLocationMarker.setMap(this.map)
                    }
                    // 将地图移动到用户的位置
                    this.map.panTo(amapLngLat)
                
            }
        },
        getCurrentPosition() {
            let self = this
            AMap.plugin('AMap.Geolocation', function () {
                var geolocation = new AMap.Geolocation({
                    // 是否使用高精度定位，默认：true
                    enableHighAccuracy: true,
                    // 设置定位超时时间，默认：无穷大
                    timeout: 10000,
                    // 定位按钮的停靠位置的偏移量，默认：Pixel(10, 20)
                    buttonOffset: new AMap.Pixel(10, 20),
                    // 定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
                    zoomToAccuracy: true,
                    // 定位按钮的排放位置, RB表示右下
                    buttonPosition: 'RB'
                })
                geolocation.getCurrentPosition()
                AMap.event.addListener(geolocation, 'complete', (e) => {
                    self.longitude = e.position.getLng()
                    self.latitude = e.position.getLat()
                })
                AMap.event.addListener(geolocation, 'error', (e) => {
                    console.log(e) // 定位失败做的事
                    switch (e.info) {
                        case 'PERMISSION_DENIED':
                            Toast('浏览器阻止了定位操作！')
                            break
                        case 'POSITION_UNAVAILBLE':
                            Toast('无法获得当前位置！')
                            break
                        case 'TIMEOUT':
                            Toast('定位超时！')
                            break
                        case 'FAILED':
                            console.log('谷歌浏览器禁止了非安全域的定位请求,正在启用百度定位')
                            self.addressDetail()
                    }

                })
            })
        },
        addressDetail() { //获取地理位置 
            var self = this
            //全局的this在方法中不能使用，需要重新定义一下
            var geolocation = new BMap.Geolocation()
            //调用百度地图api 中的获取当前位置接口
            geolocation.getCurrentPosition(function (r) {
                if (this.getStatus() == BMAP_STATUS_SUCCESS) {
                    //获取当前位置经纬度
                    var myGeo = new BMap.Geocoder()
                    myGeo.getLocation(new BMap.Point(r.point.lng, r.point.lat), function (result) {
                        if (result) {
                            self.longitude = result.point.lng
                            self.latitude = result.point.lat
                        }
                    })
                }
            })
        },
        // 查看概况，即景区详情
        toDetail() {
            if (this.isWeiXin) {
                window.uni.miniProgram.navigateTo({
                    url: `/packages/scenic/info/index?sid=${this.sid}`
                })
            } else {
                window.location.href = `${this.$baseurl}packages/scenic/info/index?sid=${this.sid}`
            }
        },
        /**
         * 显示、隐藏轨迹
         */
        walking() {
            this.walkingOpen = !this.walkingOpen
            // 广州
            // let obj1= new AMap.LngLat(113.2643600000,23.1290800000)
            // 罗定
            // let obj2= new AMap.LngLat(111.5700400000,22.7683000000)
            // console.log(obj1.distance(obj2))
            
            if (this.walkingOpen) {
                
                Toast('开启轨迹显示')

                // 经纬度数组
                let lnglatArr = []
                // 上一次获取的经纬度
                let lastLngLat
                let flag

                if(this.isWeiXin){
                
                // 获取用户当前位置
                _.geolocation().then(res => {
                    lastLngLat={lng:res.longitude,lat:res.latitude}
                    console.log('首个lastLngLat:',lastLngLat)
                    lnglatArr.push({
                        lat: res.latitude,
                        lng: res.longitude
                    })
                    this.drawLine(lnglatArr)    
                })
                
                this.interval = setInterval(() => {
                    
                    _.geolocation().then(res => {
                        flag={lng:res.longitude,lat:res.latitude}
                        console.log('flag:',flag)
                    if(flag.lng!=lastLngLat.lng||flag.lat!=lastLngLat.lat){
                        console.log('位置不相同，更新轨迹')
                        lastLngLat=flag
                        console.log('lastLngLat:',lastLngLat)
                        lnglatArr.push({
                        lat: res.latitude,
                        lng: res.longitude
                    })    
                    this.drawLine(lnglatArr)
                    }else{
                        console.log('位置相同，不更新轨迹')
                    }
                    
                }) 
                    
                }, 5000)
                }else{
                    this.getCurrentPosition()
                    lastLngLat={lng:this.longitude,lat:this.latitude}
                    console.log('首个lastLngLat:',lastLngLat)
                    lnglatArr.push({
                        lat: this.latitude,
                        lng: this.longitude
                    })
                    this.drawLine(lnglatArr) 

                    this.interval = setInterval(() => {
                        this.getCurrentPosition()
                        flag={lng:this.longitude,lat:this.latitude}
                        console.log('flag:',flag)
                    if(flag.lng!=lastLngLat.lng||flag.lat!=lastLngLat.lat){
                        console.log('位置不相同，更新轨迹')
                        lastLngLat=flag
                        console.log('lastLngLat:',lastLngLat)
                        lnglatArr.push({
                        lat: this.latitude,
                        lng: this.longitude
                    })    
                    this.drawLine(lnglatArr)
                    }else{
                        console.log('位置相同，不更新轨迹')
                    }
                    
                    
                }, 5000)
                }
            } else {
                this.closeWalking()
            }
        },
        closeWalking(){
            Toast('关闭轨迹显示')
                clearInterval(this.interval)
                //清除marker点
                this.map.remove(this.markers)
                //清除线路
                _.cleanMapOverlays(this)
        },
        /**
         * 绘制线路
         */
        drawLine(data) {
            // 获取地图实例
            this.map = this.$store.state.mapObj
            // 如果当前有点击定位后留下的“我的位置”标记点，则清除掉
            const userLocationMarker = this.$store.state.userLocationMarker
                if(userLocationMarker!=''){
                    this.map.remove(userLocationMarker)
                }
            // 经纬度数据
            const lnglatArr = []
            let distance=0
            // 获取线路的经纬度
            data.map(el => {
                el.lng = el.lng
                el.lat = el.lat
                let lnglat = []
                lnglat.push(el.lng)
                lnglat.push(el.lat)
                lnglatArr.push(lnglat)
            })
            //根据每两个点的经纬度循环计算走过的距离
            if(lnglatArr.length>1){
                let obj1;let obj2
                for(let i=0;i<lnglatArr.length-1;i++){
                    obj1= new AMap.LngLat(lnglatArr[i][0],lnglatArr[i][1])
                    obj2= new AMap.LngLat(lnglatArr[i+1][0],lnglatArr[i+1][1])
                    distance+=obj1.distance(obj2)
                    // distance+=this.distanceByLnglat(lnglatArr[i][0],lnglatArr[i][1],lnglatArr[i+1][0],lnglatArr[i+1][1])
                }
            }
            
            // 折线配置项
            const polylineOptions = {
                strokeColor: '#FE656B', // 线条颜色
                path: lnglatArr, // 折线的节点坐标数组
                strokeStyle: 'solid', // 线样式，实线:solid，虚线:dashed
                lineJoin: 'round', // 折线拐点的绘制样式，默认值为'miter'尖角，其他可选值：'round'圆角、'bevel'斜角
                strokeWeight: 3 //线宽度
            }
            // 折线实例，画线
            const polyline = this.polyline = new AMap.Polyline(polylineOptions)
            polyline.setMap(this.map)

            // 移动到最新位置点
            this.map.panTo(new AMap.LngLat(lnglatArr[lnglatArr.length - 1].lng, lnglatArr[lnglatArr.length - 1].lat))
            
            // 清除上一次画的标记点
            this.map.remove(this.markers)
            // 画标注点
            lnglatArr.forEach((el, idx) => {
                // 起点
                // if(idx == 0 && lnglatArr.length>1){
                //      // 自定义起点的样式
                //     let contentStart = `<div class='walking-marker-icon-box'></div>`

                //     // 构造一个点标记对象
                //     let markerStart = new AMap.Marker({
                //         position: el,
                //         content: contentStart,
                //         offset: new AMap.Pixel(-2,-2),
                //     })
                //     markerStart.setMap(this.map)
                //     this.markers.push(markerStart)
                // }

                if (idx == lnglatArr.length - 1) {
                    // 自定义当前最新位置点的样式
                    //    let contentEnd = '<div class="custor-marker"><div class="user-photo"></div></div>'
                   let contentEnd = `<div class="walking-location-box"><div class="top">${Math.round((distance/1000)*1000)/1000}km</div><div class="location-icon"></div></div>`

                    // 构造一个点标记对象
                   let markerEnd = new AMap.Marker({
                        position: el,
                        content: contentEnd,
                        offset: new AMap.Pixel(-44, -68),
                    })

                    markerEnd.setMap(this.map)
                    this.markers.push(markerEnd)
                    
                }
                
            })
        },
        /**
         * 获取定制内容
         */
        getCustomize(){
            // 概况
            this.axios.post(Apis.customize, {
                sid: this.sid,
                type: 4
            }).then((res) => {
                if(res.code == 200 && res.data.length) {
                    this.spots = res.data.map(v => {
                        return {
                            ...this.spots.find(x => x.key == v.key),
                            ...v
                        }
                    })
                }
            })

            // 服务
            this.axios.post(Apis.customize, {
                sid: this.sid,
                type: 5
            }).then((res) => {
                if(res.code == 200 && res.data.length) {
                    this.sers = res.data.map(v => {
                        return {
                            ...this.sers.find(x => x.key == v.key),
                            ...v
                        }
                    })
                }
            })

            // POI类型
            this.axios.post(Apis.customize, {
                sid: this.sid,
                type: 6
            }).then((res) => {
                if(res.code == 200 && res.data.length) {
                    this.getClassifys(res.data.map(v => {
                        return {
                            ...v,
                            pckey: v.key
                        }
                    }))

                    // 2022/11/29 默认图标和文字修改
                    if(!this.currentTitle && !this.currentIcon) {
                        // this.currentTitle = '设施'
                        this.currentTitle = this.$t('main.facilities')
                        this.currentIcon = require('./../../assets/new_scenic_icon.png')
                        return
                    }

                    // 获取景点的图标和标题 如果没有指定POI 即默认为景点的时候 获取默认图标和标题
                    let viewpoint = res.data.find(v => v.key == 'viewpoint')
                    let cid = this.$route.query.cid
                    if(viewpoint && (!cid || cid === 'undefined')) {
                        this.currentTitle = viewpoint.title
                        this.currentIcon = viewpoint.icon
                    }
                }
            })
        },
        showSearchBoxFun(){
            // 当展示搜索弹窗时，隐藏POI弹窗和推荐路线和景点详情弹窗
            window.hideRouteDetailFun()
            window.hidePOIBox()
            window.hideDetailFun()
            this.$bus.$emit('showSearchBoxFun', true)
        },
        showSpotFun(){
            // 当展示POI弹窗时，隐藏搜索弹窗和推荐路线和景点详情弹窗
            this.showSpot = !this.showSpot
            if(window.hideSearchBoxFun) window.hideSearchBoxFun()
            window.hideRouteDetailFun()
            window.hideDetailFun()
        }
    }
}
</script>

<style lang="scss" scoped>
.left-btn-box {
    position: fixed;
    top: .3rem;
    right: .35rem;
    // background-color: rgba($color: #fff, $alpha: 0.4);
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: .2rem;
    color: #666666;
    border-radius: .1rem;

    .item {
        width: .77rem;
        min-height: .8rem;
        background: #fff;
        box-shadow: 0 0 .5rem 0 rgba(0, 0, 0, 0.2);
        border-radius: .1rem;
        margin-bottom: .1rem;
        padding-top: .44rem;
        position: relative;
        text-align: center;

        width: .9rem;
    }
    .spot-box{
        width: 5.32rem;
        // height: 3.64rem;
        background: #FFFFFF;
        border-radius: 10px;
        position: absolute;
        left: -5.8rem;
        top: -1.2rem;
        display: flex;
        flex-wrap: wrap;
        .spot{
            width: 0.82rem;
            margin: 0.3rem 0.25rem;
        }
        img{
            width: 0.56rem;
        }
    }
    .lists{
        line-height: 1;
        // width: 6rem;
        height: 0.8rem;
        display: flex;
        justify-content: space-around;
        align-items: center;
        position: absolute;
        text-align: center;
        top: 0;
        right: 0.72rem;
        overflow: hidden;
        // background: #fff;
        background: #eee;
        box-shadow: 0px 0px 50px 0px rgba(0, 0, 0, 0.2);
        border-radius: 10px 0 0 10px;
        // font-size: 0.1rem;
        padding: 4px 0;

        right: .9rem;
        .spot{
            // max-width: 1rem;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            margin: 0 0.1rem;
            font-size: 0.22rem;
            // height: 0.8rem;
        }
        img{
            width: .35rem;
            height: .35rem;
        }
    }
    .draw-enter-active, .draw-leave-active {
        transition: all 0.5s ease;
    }
    .draw-enter, .draw-leave-to /* .fade-leave-active below version 2.1.8 */ {
        width: 0;
    }


    .item:last-child {
        margin-bottom: 0;
    }

    .map {
        background: #fff url('../../assets/left_btn_map.png') no-repeat center .1rem/.36rem .36rem;
    }

    .detail {
        background: #fff url('../../assets/left_btn_detail.png') no-repeat center .1rem/.36rem .36rem;
    }
    .indoor {
        background: #fff url('../../assets/left_btn_indoor.png') no-repeat center .1rem/.42rem .36rem;
    }
    .spot-icon{
        // position: absolute;
        // bottom: -7.2rem;
        margin-top: 15vh;
        background: #fff url('../../assets/classify_allactive_scenic.png') no-repeat center .1rem/.36rem .36rem;
    }
    // 重构结构实现动态图标
    .spot-icon{
        background: #fff;
        // padding-top: 0;

        background: rgb(164, 224, 255);
        &>img{
            width: 0.35rem;
            height: 0.35rem;
            display: block;
            margin: 0.08rem auto 0;
        }
    }
     .audio-icon{
        // position: absolute;
        // bottom: -7.2rem;
        margin-top: 0.1rem;
        background: #fff url('../../assets/audio-icon.png') no-repeat center .1rem/.36rem .36rem;
    }
    .check-icon{
        margin-top: 0.1rem;
        background: #fff url('../../assets/check-icon.png') no-repeat center .1rem/.36rem .36rem;
    }
    .serve-icon{
        background: #fff url('../../assets/serve-icon.png') no-repeat center .1rem/.36rem .36rem;
    }
    .position {
        background: #fff url('../../assets/left_btn_position.png') no-repeat center .1rem/.36rem .36rem;
    }

    .walk {
        background: #fff url('../../assets/left_btn_walk.png') no-repeat center .1rem/.36rem .36rem;
    }

    .switch {
        background: #fff url('../../assets/left_btn_switch.png') no-repeat center .1rem/.36rem .36rem;
    }
    .large {
        background: #fff url('../../assets/large.png') no-repeat center .1rem/.36rem .36rem;
    }
    .small {
        background: #fff url('../../assets/small.png') no-repeat center .1rem/.36rem .36rem;
    }

    .walking {
        background-color: #ddd;
        border: 1px solid #666;
    }

    .items {
        margin-top: 15vh;
        width: 1.12rem;
        background: #FFFFFF;
        box-shadow: 0 0 .05rem .01rem rgba(138,138,138,0.54);
        border-radius: .20rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: .26rem;
        .item {
            box-shadow: none;
            width: .8rem;
            margin-top: 0;
            margin-bottom: .2rem;
            border-radius: .10rem;
        }
        .spot-icon{
            // position: absolute;
            // bottom: -7.2rem;
            margin-top: 0;
            background: #EBF8FF url('../../assets/classify_allactive_scenic.png') no-repeat center .1rem/.36rem .36rem;
        }
        .audio-icon {
            background: #FFE1BB url('../../assets/audio-new-icon.png') no-repeat center .1rem/.36rem .36rem;
        }
        .check-icon {
            background: #EFF2FF url('../../assets/check-new-icon.png') no-repeat center .1rem/.36rem .36rem;
        }
    }
}

.nav-box {
    position: relative;
    font-size: 0.24rem;
    white-space: nowrap;
    color: #888;
    background: rgba($color: #fff, $alpha: 0.8);
    width: 0.6rem;
    border-radius: 0.6rem;
    outline: none;
    margin: 0 auto;

    .text {
        line-height: 0.6rem;
        text-align: center;
    }

    .yb-btn {
        position: absolute;
        top: 0.05rem;
        left: 0.05rem;
        background: #48c1ff;
        border-radius: 50%;
        width: 0.5rem;
        height: 0.5rem;
    }

    &.on .yb-btn {
        top: auto;
        bottom: 0.05rem;
    }
}

.tc-icon {
    width: 0.6rem;
    height: 0.6rem;
    margin-top: 0.2rem;
    background: #fff;
    border-radius: 50%;
    padding: 0.15rem 0.1rem;
    overflow: hidden;
    box-shadow: 0 0 0.5rem rgba($color: #000000, $alpha: 0.2);

    img {
        max-width: 100%;
        max-height: 100%;
        display: block;
    }

    .text {
        font-size: 0.16rem;
        color: #888;
        background: rgba($color: #fff, $alpha: 0.8);
        border-radius: 0.3rem;
    }
}

.tc-masker {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 192;
    background: rgba($color: #000000, $alpha: 0.4);
    display: none;

    &.show {
        display: block;
    }
}

.tc-select-box {
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 193;
    width: 5rem;
    transform: translate(-50%, -50%);
    display: none;

    .tc-item {
        height: 1.2rem;
        line-height: 1.2rem;
        background: #fff;
        border-radius: 0.6rem;
        padding: 0 0.5rem;
        margin-bottom: 0.3rem;
        color: #999;
        font-size: 0.44rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        box-shadow: 0 0 0.5rem rgba(0, 0, 0, 0.2);

        &:last-child {
            margin-bottom: 0;
        }

        &.on {
            color: #ff5c01;
        }
    }

    &.show {
        display: block;
    }
}
</style>
